export default (link: string) => !/https?:\/\/.+/.test(link)
